var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6601 1.55177C14.2372 1.11946 8.46267 1.11946 3.33666 1.55177C2.53379 1.64441 1.85444 2.09216 1.29861 2.89503C0.742777 3.6979 0.418541 4.53165 0.325903 5.39628C0.109745 8.2372 0.109745 11.0781 0.325903 13.919C0.418541 14.7837 0.742777 15.6174 1.29861 16.4203C1.85444 17.2232 2.53379 17.6864 3.33666 17.8099C9.57434 18.2113 15.3488 18.2113 20.6601 17.8099C21.463 17.6555 22.1423 17.1768 22.6982 16.374C23.254 15.5711 23.5782 14.7528 23.6709 13.919C23.887 11.0164 23.887 8.09824 23.6709 5.16468C23.5782 4.26918 23.2694 3.45087 22.7445 2.70976C22.2504 1.96865 21.5556 1.58265 20.6601 1.55177ZM9.03395 13.8727V5.34996L16.445 9.61134L9.03395 13.8727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.8779770fdb71fed960791ab9a3ec7870.svg";
export { ForwardRef as ReactComponent };